<template>
<div>
  <template v-if="$route.name === 'EXCMNotificationMessageCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXCMNotificationMessageList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </template>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        title: '',
        description: '',
        mailTitle: '',
        mailBody: '',
        taskType: null,
        caseType: null,
        firingThrough: null,
        dayAfterStart: 0,
        recipientType: [],
        recipientTypeCc: [],
        sendAttachments: 0,
        sendAttachmentsFromCaseInTask: 0,
        senderType: null,
        messageType: [],
        smsBody: '',
        allowedDocumentTypes: [],
        repeatAgainCount: 0,
        repeatAgainInterval: 0,
        customToUsers: '',
        customCcUsers: '',
        emergencyEmail: '',
        emergencyText: '',
        customToUsersFromCustomFields: '',
        customCcUsersFromCustomFields: ''
      }
    }
  },
  watch: {
    created (val) {
      if (val) this.$router.push({ name: 'EXCMNotificationMessageList' })
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMNotificationMessageList')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'excmnotificationmessage/create/created',
      violations: 'excmnotificationmessage/create/violations',
      isLoading: 'excmnotificationmessage/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'excmnotificationmessage/create/create',
      reset: 'excmnotificationmessage/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
